import React from 'react';
import InstantEditBox from '../ui/InstantEditBox.jsx';

class WidgetToolbarComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {isPaused: false};
	}

	onPauseClick() {
		var oldval = this.state.isPaused;
		this.setState({isPaused: !oldval});
		this.props.onPauseClick.call(null, this.state.isPaused);
	}

	onRefreshClick() {
		this.props.onRefreshClick.call(null);
		//this.setState({isPaused: false});
	}

	onInfoClick() {
		this.props.onInfoClick.call(null);
	}

	onFailClick() {
		this.props.onFailClick.call(null);
	}

	onCloseClick() {
		this.props.onCloseClick.call(null);
	}

	onTitleChanged(newval) {
		this.props.onTitleChanged.call(null, newval);
	}

	onSnapshotClick(){
		console.log("on onSnapshotClick");
		this.props.onSnapshotClick.call(null);	
	}

	render() {
		var iconClass = 'btn-unobt btn-extra-mini b-pause';
		var icon = (<i className="vicon-fa-small vicon-pause-gray"></i>);

		if(this.state.isPaused) {
			iconClass = 'btn-unobt btn-extra-mini b-play';
			icon = (<i className="fa fa-play"></i>);
		}

		var snapShot;

		var elClose,
			elBrokenStyle = {
				marginLeft: '-11px',
				padding: '1px 5px 2px 7px',
				background: 'transparent',
				border: 'none',
				outline: 'none'
			},
			elBroken = (<button className="btn-query-failed" onClick={this.onFailClick.bind(this)} style={elBrokenStyle}><i className="fa fa-exclamation-triangle"></i></button>),
			elTitle = (<div className="widget-title">{this.props.isDataSourceBroken ? elBroken : ''} <span className="title">{this.props.children}</span></div>);
		
		if(!this.props.isReadOnly) {
			elTitle = (<div className="widget-title">
				{this.props.isDataSourceBroken ? elBroken : ''}
				<InstantEditBox onChange={this.onTitleChanged.bind(this)} model={this.props.children}></InstantEditBox>
			</div>);
			elClose = (<button className="btn-unobt btn-extra-mini b-x" onClick={this.onCloseClick.bind(this)}><i className="fa fa-times"></i></button>);
			// snapShot = (<button className="btn-unobt btn-extra-mini b-x" onClick={this.onSnapshotClick.bind(this)}><i className="fa fa-download"></i></button>);
		}

		if(!!this.props.isStreamQuery){
			return (
				<div className="widget-toolbar">
					{elTitle}
					<span className="widget-toolbox">
						<button className={iconClass} onClick={this.onPauseClick.bind(this)}>{icon}</button>
						<button className="btn-unobt btn-extra-mini b-p" onClick={this.onInfoClick.bind(this)}><i className="fa fa-info"></i></button>
						{/*{snapShot}*/}
						{elClose}
					</span>
				</div>
			)
		} 
		else if(!!this.props.isCustomQuery){
			return (
				<div className="widget-toolbar">
					{elTitle}
					<span className="widget-toolbox">
						<button className="btn-unobt btn-extra-mini b-p" onClick={this.onInfoClick.bind(this)}><i className="fa fa-info"></i></button>
						{/*{snapShot}*/}
						{elClose}
					</span>
				</div>
			)
		}
		else if(this.props.isLoading) {
			return (
				<div className="widget-toolbar">
					{elTitle}
					<span className="widget-toolbox">
						<button className={iconClass} onClick={this.onPauseClick.bind(this)}>{icon}</button>
						<button className="btn-unobt btn-extra-mini b-refresh" onClick={this.onRefreshClick.bind(this)}><i className="fa fa-refresh"></i></button>
						<button className="btn-unobt btn-extra-mini b-p" onClick={this.onInfoClick.bind(this)}><i className="fa fa-info"></i></button>
						{/*{snapShot}*/}
						{elClose}
					</span>
				</div>
			)
		}
		else if(this.props.isDataSourceBroken) {
			return (
				<div className="widget-toolbar">
					{elTitle}
					<span className="widget-toolbox">
						<button className="btn-unobt btn-extra-mini b-refresh" onClick={this.onRefreshClick.bind(this)}><i className="fa fa-refresh"></i></button>
						<button className="btn-unobt btn-extra-mini b-p" onClick={this.onInfoClick.bind(this)}><i className="fa fa-info"></i></button>
						{elClose}
					</span>
				</div>
			)
		}
		else {
			return (
				<div className="widget-toolbar">
					{elTitle}
					<span className="widget-toolbox">
						<button className={iconClass} onClick={this.onPauseClick.bind(this)}>{icon}</button>
						<button className="btn-unobt btn-extra-mini b-refresh" onClick={this.onRefreshClick.bind(this)}><i className="fa fa-refresh"></i></button>
						<button className="btn-unobt btn-extra-mini b-p" onClick={this.onInfoClick.bind(this)}><i className="fa fa-info"></i></button>
						{/*{snapShot}*/}
						{elClose}
					</span>
				</div>
			)
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
    	// return a boolean value
    	return true;
	}

	componentWillUpdate(nextProps, nextState){
    // perform any preparations for an upcoming update
    	this.props = nextProps;
	}
};

WidgetToolbarComponent.defaultProps = {
	isLoading: true
}

export default WidgetToolbarComponent;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/WidgetToolbarComponent.jsx